import { Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

const SPECIALTIES = [
  "Wound Care",
  "Wound Vac",
  "PICC Line",
  "Dementia",
  "Trache",
  "IV",
  "TPN",
] as const;

export interface AddVisitStep2Data {
  specialties: string[];
  description: string;
}

interface Props {
  data: AddVisitStep2Data;
  onChange: (field: keyof AddVisitStep2Data, value: string | string[]) => void;
}

export function MobileAddVisitStep2({ data, onChange }: Props) {
  function toggleSpecialty(specialty: string) {
    const updated = data.specialties.includes(specialty)
      ? data.specialties.filter((s) => s !== specialty)
      : [...data.specialties, specialty];
    onChange("specialties", updated);
  }

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Text semibold variant="body1">
          Specialties
        </Text>
        <Stack>
          {SPECIALTIES.map((specialty) => (
            <FormControlLabel
              key={specialty}
              label={specialty}
              control={
                <Checkbox
                  checked={data.specialties.includes(specialty)}
                  onChange={() => {
                    toggleSpecialty(specialty);
                  }}
                />
              }
            />
          ))}
        </Stack>
      </Stack>

      <Stack spacing={0.5}>
        <Text semibold variant="body1">
          Description
        </Text>
        <Text variant="body2" sx={{ color: "text.secondary", fontStyle: "italic" }}>
          Visible to professionals
        </Text>
        <TextField
          multiline
          minRows={4}
          fullWidth
          value={data.description}
          onChange={(e) => {
            onChange("description", e.target.value);
          }}
          sx={{
            mt: 0.5,
            bgcolor: "background.paper",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": { borderRadius: 2 },
          }}
          inputProps={{ "data-dd-privacy": "mask" }}
        />
      </Stack>
    </Stack>
  );
}
